import {
  Component,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { CatalogService } from "@services/catalog.service";

declare var gapi;

@Component({
  selector: "ga-report",
  templateUrl: "./ga-report.component.html",
})
export class GAReportComponent implements AfterViewInit {
  _query: any;
  report: any;
  results = [];

  _startDate: string;
  _endDate: string;

  constructor(private catalogService: CatalogService, private zone: NgZone) {}

  @Input()
  set startDate(startDate: string) {
    this._startDate = startDate;
    this.updateChart();
  }

  @Input()
  set endDate(endDate: string) {
    this._endDate = endDate;
    this.updateChart();
  }

  @Input()
  set query(query: any) {
    this._query = Object.assign({}, query);
    this.updateChart();
  }

  updateChart() {
    if (this.report) {
      this.report
        .set({
          query: Object.assign({}, this.query, {
            "start-date": this._startDate,
            "end-date": this._endDate,
          }),
        })
        .execute();
    }
  }

  get query() {
    return this._query;
  }

  ngAfterViewInit(): void {
    this.report = new gapi.analytics.report.Data({
      query: Object.assign({}, this.query, {
        "start-date": this._startDate,
        "end-date": this._endDate,
      }),
    });
    this.report.on("success", (response) => {
      this.zone.run(() => {
        this.results = response.rows;
        console.log("results", this.results);
        if (this.results) {
          this.results.forEach((result) => {
            this.catalogService
              .getCatalog(result[0])
              .then((catalog) => (result[3] = catalog.title));
          });
        }
      });
    });
    this.report.execute();
  }
}
